(function(jQuery) {

	jQuery(function($){

        var openQuestion = function(hash)
		{
            if ( Nwdthemes.Faqpage.mode != 'collapse' ) return;

			if ( hash.indexOf('faq_') > -1 ) {
                $('#faq_'+hash.split('_')[1]+' a').trigger('open');
                $(hash+' a').trigger('open');

				window.location.hash = hash;
			}
		}

		new jQueryCollapse($("#faqpage"), {
			open: function() {
				this.slideDown(150);
			},
			close: function() {
				this.slideUp(150);
			}
		});
		new jQueryCollapse($(".faqpage_question_wrapper"), {
			open: function() {
				this.slideDown(150);
			},
			close: function() {
				this.slideUp(150);
			}
		});

		//check hash on page load
		openQuestion(window.location.hash);

		$('.faqpage_side_block a').click(function(){
			openQuestion('#'+$(this).attr('href').split('#')[1]);
			return false;
		});
      
      	
$('#faq-search').on('keydown', function(event) {
   var x = event.which;
   if (x === 13) {
       event.preventDefault();
   }
});

        //live search
        var highlight_settings = { className: 'faq-highlight', element: 'span' };


        if ( Nwdthemes.Faqpage.mode == 'collapse' ) {
            //collapse mode


            $("#faq-search").keyup(function(){
                //remove highlights
                $('.faqpage-container').unhighlight(highlight_settings);

                //$(".faqpage_question_wrapper > h3 a").trigger('close');
                //$("#faqpage > h2 a").trigger('close');

                var filter = $(this).val(),
                    count = 0,
                    found_title = false,
                    found_body = false;
                $(".faqpage_question_wrapper").each(function(){
                    //check question title
                    found_title = $('h3.faqpage_question', this).text().search(new RegExp(filter, "i"));
                    //check question body
                    found_body = $('.faqpage_answer', this).text().search(new RegExp(filter, "i"));

                    if (found_title < 0 && found_body < 0 ) {
                        $("> h3 a", this).trigger('close');
                    } else {
                        $("> h3 a", this).trigger('open');
                        $(this).parent().prev().find("a").trigger('open');
                        count++;
                    }
                });

                //close categories without matches
                $(".faqpage_category.open").each(function(){
                    if ( !$(this).next().find('.faqpage_question.open').length ) {
                        $('a', this).trigger('close');
                    }
                });

                // Update the count
                $("#faq-search-count").text(count + Nwdthemes.Faqpage.translate.results);

                //highlight results
                $('.faqpage-container').highlight(filter, highlight_settings);

            });

            $('#faq-reset').click(function(){
                $("#faq-search").val('');
                $('.faqpage-container').unhighlight(highlight_settings);
                $("#faq-search-count").text('');
                return false;
            });

        } else {
            //default mode
            $("#faq-search").keyup(function(){
                //remove highlights
                $('.faqpage-container').unhighlight(highlight_settings);

                var filter = $(this).val(),
                    count = 0,
                    found_title = false,
                    found_body = false;
                $(".faqpage_question_block").each(function(){
                    //check question title
                    found_title = $('h3.faqpage_question', this).text().search(new RegExp(filter, "i"));
                    //check question body
                    found_body = $('.faqpage_answer', this).text().search(new RegExp(filter, "i"));

                    if (found_title < 0 && found_body < 0 ) {
                        $(this).fadeOut();
                    } else {
                        $(this).show();
                        count++;
                    }
                });

                // Update the count
                $("#faq-search-count").text(count + Nwdthemes.Faqpage.translate.results);

                //highlight results
                $('.faqpage-container').highlight(filter, highlight_settings);

            });

            $('#faq-reset').click(function(){
                $("#faq-search").val('');
                $(".faqpage_question_block").show();
                $('.faqpage-container').unhighlight(highlight_settings);
                $("#faq-search-count").text('');
                return false;
            });

            $('.faqpage_list_categories a').click(function(){
                $('#faq-reset').trigger('click');
                return true;
            });
        }

// ask a question

		$('.nwdthemes_faq_ask_button').on('click', function() {
			$('.nwdthemes_ask_question').slideDown(150);
			$('html, body').animate({scrollTop: $('.nwdthemes_ask_question').offset().top}, 150);
			$('.nwdthemes_faq_ask_button').hide();
			var dataForm = new VarienForm('nwdthemes_faq_ask_form', true);
		});
		$('.nwdthemes_cancel_faq_ask').on('click', function() {
			$('.nwdthemes_faq_ask_button').show();
			$('.nwdthemes_ask_question').slideUp(150);
		});

	});

})(jQuery);
    if (typeof Nwdthemes == "undefined") var Nwdthemes = {};
    if (typeof Nwdthemes.Faqpage == "undefined") Nwdthemes.Faqpage = {};

    Nwdthemes.Faqpage.mode = 'collapse';
    Nwdthemes.Faqpage.translate = {};
    Nwdthemes.Faqpage.translate.results = ' results found.';